var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21C22.6569 0 24 1.34315 24 3V24H0V0Z",
    fill: "#262626",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 5.8125L17.625 18.1875",
    stroke: "#333333",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8917 14.0811C13.3398 14.5828 12.6112 14.8447 11.8661 14.8092C11.1211 14.7737 10.4207 14.4437 9.91893 13.8918C9.41719 13.3399 9.15524 12.6113 9.19068 11.8662C9.22613 11.1212 9.55607 10.4207 10.1079 9.91895",
    stroke: "#333333",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20274 7.82324C5.33615 9.27488 4.125 12.0003 4.125 12.0003C4.125 12.0003 6.375 17.0622 12 17.0622C13.3179 17.0727 14.6194 16.7691 15.7967 16.1766",
    stroke: "#333333",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.667 14.8899C19.1999 13.5169 19.8741 12.0001 19.8741 12.0001C19.8741 12.0001 17.6241 6.93702 11.9991 6.93702C11.512 6.93623 11.0256 6.97583 10.5449 7.05544",
    stroke: "#333333",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5293 9.2373C13.1271 9.35209 13.6715 9.6576 14.081 10.108C14.4904 10.5584 14.7428 11.1294 14.8002 11.7354",
    stroke: "#333333",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.479096a55d8d886c681d7430d9165e4c.svg";
export { ForwardRef as ReactComponent };